import { CancellationToken } from '@cian/http-api';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { type TJsonQuery } from '@/packages/JsonQuery';

import { prepareSearchMetaData } from '@/microfrontends/filters/shared/mappers/prepareSearchMeta';
import { type ISearchMeta } from '@/microfrontends/filters/shared/types/searchMeta';

import { fetchGetMetaWithFixedGeo } from '../../../services/fetchGetMetaWithFixedGeo';
import { type TThunkApi } from '../../types';

let cancellationToken: CancellationToken | null = null;

export const updateSearchMeta = createAsyncThunk<ISearchMeta, void, TThunkApi>(
  'searchMeta/update',
  async (_, thunkApi) => {
    const { rejectWithValue, extra, getState } = thunkApi;
    const state = getState();
    const jsonQuery: TJsonQuery = state.jsonQuery.current;
    const location = state.location.data;

    if (cancellationToken) {
      cancellationToken.cancel();
    }

    cancellationToken = new CancellationToken();

    const metaResult = await fetchGetMetaWithFixedGeo(extra, { jsonQuery, location }, { cancellationToken });

    // Здесь возвращаем причину reject-а. Если предыдущий запрос здесь был отменён, то значит updateMeta
    // был запрошен повторно. Следовательно, не нужно скрывать спиннер, а продолжать процесс загрузки.
    // Если этого не делать, то будет рассинхрон состояния.
    // На данный момент нельзя отловить через metaResult.isErrAnd(HttpCancelError.is),
    // поскольку прилетает UnknownError если запрос был отменён через cancellationToken.cancel();
    return metaResult
      .map(prepareSearchMetaData)
      .unwrapOrElse(err =>
        err.message.toLowerCase().includes('canceled') ? rejectWithValue('canceled') : rejectWithValue(null),
      );
  },
);
